import axios from 'axios';

function base_url(site_path, id) {
  if (id !== undefined) {
    return `${site_path}/excel2bp/${id}/`;
  }
  return `${site_path}/excel2bp/`;
}


export default {
  get_template: async (absolute_url) => {
    const response = await axios.get(absolute_url, {responseType: 'blob'});
    return response.data;
  },

  list_templates: async (site_path) => {
    const response = await axios.get(base_url(site_path) + 'list_templates/');
    return response.data;
  },

  convert: async (site_path, data) => {
    const response = await axios.post(base_url(site_path) + 'convert/', data);
    return response.data;
  },
};
